export const experienceData = [
    {
        id: 1,
        company: 'Positive Ads Management',
        jobtitle: 'WordPress developer',
        startYear: '2020',
        endYear: '2022'
    },
    {
        id: 2,
        company: 'Freelance',
        jobtitle: 'Full-stack Developer',
        startYear: '2022',
        endYear: 'Present'
    },
]